import { render, staticRenderFns } from "./eVideo.vue?vue&type=template&id=32977d2a&scoped=true&"
import script from "./eVideo.vue?vue&type=script&lang=js&"
export * from "./eVideo.vue?vue&type=script&lang=js&"
import style0 from "./eVideo.vue?vue&type=style&index=0&id=32977d2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32977d2a",
  null
  
)

export default component.exports